import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout, FormError, FormNotice, authButton, authInput } from "@/components/auth/AuthLayout";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/password-reset", { email: email.trim() }, { auth: false });
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      testId="forgot-password-page"
      title="Reset your password"
      subtitle="Enter your account email and we'll send you a reset link."
      footer={<Link to="/sign-in" className="text-white underline-offset-4 hover:underline" data-testid="forgot-back-to-sign-in">Back to sign in</Link>}
    >
      <form onSubmit={submit} className="space-y-3.5">
        <input type="email" required autoComplete="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} data-testid="forgot-email-input" />
        <FormError>{error}</FormError>
        {sent && <FormNotice testId="forgot-sent-notice">If an account exists for that email, a reset link is on its way. It works once and expires in about an hour.</FormNotice>}
        <button type="submit" disabled={busy} className={authButton} data-testid="forgot-submit-button">
          {busy ? "Sending…" : sent ? "Send again" : "Send reset link"}
        </button>
      </form>
    </AuthLayout>
  );
}
